// Для отправки данных с помошью axios
export default function formData(objectData) {
  const data = new FormData();
  Object.keys(objectData).forEach((key) => data.set(key, objectData[key]));
  return data;
}
